/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type Donation_configuration = {
    readonly currency: string;
    readonly donationAmountSuggestions: ReadonlyArray<number> | null;
    readonly donationRoundUp: boolean;
    readonly " $refType": "Donation_configuration";
};
export type Donation_configuration$data = Donation_configuration;
export type Donation_configuration$key = {
    readonly " $data"?: Donation_configuration$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"Donation_configuration">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Donation_configuration",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "donationAmountSuggestions",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "donationRoundUp",
            "storageKey": null
        }
    ],
    "type": "Configuration",
    "abstractKey": null
} as any;
(node as any).hash = '98bca41c45c340e0ccefbc55372050f7';
export default node;
